import React, { Component } from 'react';
import { TEXT_LINK, IMAGE_LINK } from 'helpers/constants';
import { CustomInput } from 'reactstrap';

class RadioBtnGroup extends Component {
  render() {
    const { textGroup, value, handleChange } = this.props;

    return (
      <div className="radio-group">
        <div className="radio-group__text">{textGroup}</div>
        <CustomInput
          type="radio"
          id="create-button-link"
          label="Button link"
          name="radio-create-link"
          value={TEXT_LINK}
          checked={value === TEXT_LINK}
          onChange={handleChange}
        />
        <CustomInput
          type="radio"
          id="create-image-link"
          label="Image link"
          name="radio-create-link"
          value={IMAGE_LINK}
          checked={value === IMAGE_LINK}
          onChange={handleChange}
        />
      </div>
    );
  }
}

export default RadioBtnGroup;



// WEBPACK FOOTER //
// ./src/components/RadioBtnGroup/RadioBtnGroup.js